import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';

const SearchRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: 12,
  backgroundColor: alpha(theme.palette.common.black, 0.04),
  width: '100%',
  margin: 0,
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.07),
  },
}));

/** 돋보기 오른쪽 — 입력은 왼쪽부터 자연스럽게 (pointer-events 없음) */
const SearchIconAffix = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 1.25),
  height: '100%',
  position: 'absolute',
  right: 0,
  top: 0,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1.25, 1.25),
    paddingRight: `calc(44px + ${theme.spacing(1)})`,
    fontSize: 14,
  },
}));

/**
 * @param {string} value
 * @param {(e: React.ChangeEvent<HTMLInputElement>) => void} onChange — 네이티브 change 이벤트
 */
export default function PrimarySearchBar({ value, onChange, placeholder = 'Search…' }) {
  return (
    <Box sx={{ flexGrow: 1, minWidth: 0, width: '100%' }}>
      <SearchRoot>
        <StyledInputBase
          placeholder={placeholder}
          inputProps={{ 'aria-label': 'search' }}
          value={value}
          onChange={onChange}
        />
        <SearchIconAffix>
          <SearchIcon
            sx={{
              color: '#551FFF',
              background: '#EDE8FF',
              padding: '6px',
              borderRadius: '8px',
              fontSize: 20,
            }}
          />
        </SearchIconAffix>
      </SearchRoot>
    </Box>
  );
}
